<template>
    <div class="modal-panel fixed w-full h-full top-0 left-0 flex justify-center items-center">
        <div class="absolute bg-gray-700 opacity-50 w-full h-full top-0 left-0"></div>
        <div class="relative bg-white rounded shadow-lg border border-gray-600 w-full max-w-md">
            
            <slot></slot>
        </div>
        
    </div>
    
</template>

<script>


export default {

    name: "modal-panel",
    components: {
        
    }

}
</script>

<style scoped>


</style>